import './mocks/window-setup';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './App.css'
import AppStatic from './AppStatic'

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <AppStatic />
    </StrictMode>,
)
